module.exports = __webpack_public_path__ + "static/img/Dragon.ffd1cd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Dragon.svg
// module id = 1359
// module chunks = 0